/**
 * Mobile Profile View
 * Shows user info and logout option
 */

import React from 'react';
import { User, Mail, Building2, Shield, LogOut, Smartphone, Info } from 'lucide-react';
import { useMobileAuth } from '../MobileApp';

export default function ProfileView({ onLogout }) {
  const { user } = useMobileAuth();

  const handleLogout = () => {
    if (window.confirm('Voulez-vous vraiment vous deconnecter ?')) {
      onLogout();
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <header className="bg-slate-800 border-b border-slate-700 px-4 py-3 safe-area-top">
        <h1 className="text-xl font-bold text-white">Profil</h1>
      </header>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {/* User Card */}
        <div className="bg-slate-800 rounded-xl p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
              {user?.first_name?.[0] || user?.email?.[0]?.toUpperCase() || 'U'}
            </div>
            <div>
              <h2 className="text-lg font-semibold text-white">
                {user?.display_name || `${user?.first_name} ${user?.last_name}` || 'Utilisateur'}
              </h2>
              <p className="text-sm text-slate-400">{user?.role || 'User'}</p>
            </div>
          </div>

          <div className="space-y-3 border-t border-slate-700 pt-4">
            <div className="flex items-center gap-3 text-slate-300">
              <Mail className="w-5 h-5 text-slate-500" />
              <span className="text-sm">{user?.email}</span>
            </div>
            {user?.org_name && (
              <div className="flex items-center gap-3 text-slate-300">
                <Building2 className="w-5 h-5 text-slate-500" />
                <span className="text-sm">{user.org_name}</span>
              </div>
            )}
            <div className="flex items-center gap-3 text-slate-300">
              <Shield className="w-5 h-5 text-slate-500" />
              <span className="text-sm capitalize">{user?.role || 'user'}</span>
            </div>
          </div>
        </div>

        {/* App Info */}
        <div className="bg-slate-800 rounded-xl overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-700">
            <h3 className="font-medium text-white flex items-center gap-2">
              <Smartphone className="w-5 h-5 text-slate-400" />
              Application
            </h3>
          </div>
          <div className="divide-y divide-slate-700">
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-400">Version</span>
              <span className="text-sm text-white">1.0.0</span>
            </div>
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-400">Plateforme</span>
              <span className="text-sm text-white">PWA</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="bg-slate-800 rounded-xl overflow-hidden">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-4 flex items-center gap-3 text-red-400 hover:bg-slate-700/50 active:bg-slate-700 transition-colors"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Se deconnecter</span>
          </button>
        </div>

        {/* Footer */}
        <div className="text-center text-slate-500 text-xs py-4">
          <p>FleetManager Mobile</p>
          <p className="mt-1">© 2024 FleetManager</p>
        </div>
      </div>
    </div>
  );
}
